module.exports = __webpack_public_path__ + "img/highSpeedRail-3.5b05d228.jpg";